module.exports = __webpack_public_path__ + "static/media/MenuAppleSalad.693bcfa5.jpg";